import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { RateSelectPillComponent } from './rate-select-pill.component';

@NgModule({
  declarations: [RateSelectPillComponent],
  imports: [CommonModule],
  exports: [RateSelectPillComponent],
})
export class RateSelectPillModule {}
